"use client";

import { Ref } from "react";
import { Plus } from "lucide-react";
import { Text } from "@leabankab/component-library";

interface AddDebtButtonProps {
	title: string;
	onClick: () => void;
	ref?: Ref<HTMLButtonElement>;
}

export const AddDebtButton = ({ title, onClick, ref }: AddDebtButtonProps) => (
	<button
		ref={ref}
		type="button"
		onClick={onClick}
		className="flex w-full cursor-pointer items-center justify-start gap-1.5 rounded-xl border border-dashed border-primary-subtle p-1.5 text-primary-base hover:bg-purple-50"
	>
		<div className="flex size-4 items-center justify-center rounded-full bg-primary-subtle">
			<Plus size={16} aria-hidden="true" />
		</div>
		<Text fontWeight="medium" color="inherit">
			{title}
		</Text>
	</button>
);
